import { create } from "zustand";
import type { CommitmentsState } from "./types";

const useCommitmentsStore = create<CommitmentsState>((set, get) => ({
    commitmentsData: undefined,
    setCommitmentsData: (data) => set({ commitmentsData: data }),
    unresolvedLiquidityCount: undefined,
    setUnresolvedLiquidityCount: (count) => set({ unresolvedLiquidityCount: count }),
    reset: () => set({ commitmentsData: undefined }),
    reloadCommitments: undefined,
    setReloadCommitments: (fn) => set({ reloadCommitments: fn }),
}));

export { useCommitmentsStore };

